import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import img01 from './../assets/solutions_products/solution.png'; // Adjust the path as necessary
import img02 from './../assets/solutions_products/cybersecurity.png'; // Adjust the path as necessary
import img03 from './../assets/solutions_products/power_by_orca.png'; // Adjust the path as necessary
import 'animate.css/animate.min.css'; // Import animate.css for animations



export default function Digital() {
    return (
        <Container className='digital'>
            <h2 className="text-center title"> Digital Infrastructure & Integration</h2>
            <Row>
                <div className='responsive-title'>Build Smart. Scale Fast. Run Smooth</div>
            </Row>
            <Row className='mt-4'>
                <p className='text-center mb-4 content'>
                    We help businesses design, develop, and run intelligent IT ecosystems that adapt to their growth. From agile infrastructure and enterprise hardware to AI-powered systems and tailored development. We build IT that works, talks, and evolves with you.
                </p>
            </Row>

            <Row>
                <div className='mb-4 box'>
                    <Row>
                        <Col md={6}>
                            <div className='box-title'>
                                What Powers It All:
                            </div>
                        </Col>
                        <Col md={6} className="text-end">

                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className='mt-4'>
                            <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInDown" duration={.5} offset={100}>
                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Infrastructure as a Service (IaaS) & On-Premise Setup</h4>
                                    <p>Flexible IT foundations deploy anywhere, scale anytime, on your terms.</p>
                                </div>

                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Custom IT Development & Workflow Automation</h4>
                                    <p>Build smarter systems that automate the busywork and speed up execution.</p>
                                </div>
                                <div style={{ marginBottom: '20px' }}>
                                    <h4>AI-Driven Command & Control Platforms</h4>
                                    <p>Centralized dashboards with intelligent insights to monitor, act, and optimize in real time.</p>
                                </div>
                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Revenue Assurance & Fraud Management Systems</h4>
                                    <p>Minimize revenue leakage and detect anomalies before they become losses.</p>
                                </div>
                            </AnimationOnScroll>

                        </Col>
                        <Col md={6} className='mt-4'>
                            <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={.5} offset={100}>
                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Project Orchestration & System Integration</h4>
                                    <p>Connect the dots across your tech stack no silos, no friction.</p>
                                </div>

                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Real-Time Monitoring & Performance Dashboards</h4>
                                    <p>Make decisions backed by live metrics, not gut feeling.</p>
                                </div>
                                <div style={{ marginBottom: '20px' }}>
                                    <h4>Digital Experience & Interface Engineering</h4>
                                    <p>Design seamless digital journeys that are as functional as they are beautiful.</p>
                                </div>
                                <div style={{ marginBottom: '20px' }}>
                                    <h4>IT Operations & Support Services for Scale</h4>
                                    <p>Run with confidence we help manage, maintain, and optimize your IT ops at every level.</p>
                                </div>
                            </AnimationOnScroll>
                        </Col>
                    </Row>
                </div>
            </Row>


        </Container>
    )

}
